import React from 'react';
import { NavLink } from 'react-router-dom';

const NavLinks = () => {
  return(
    <ul className="nav">
      <li><NavLink activeClassName='active' to='/apps'>Apps</NavLink></li>
      <li><NavLink activeClassName='active' exact to='/browse'>Browse</NavLink></li>

    </ul>
  );
}

export default NavLinks;


// WEBPACK FOOTER //
// ./src/components/NavLinks.js